let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iiMWZ")).then(() => parcelRequire('8Ugl4'));